import React, {useState, useEffect}  from "react";
import classes from './Timer.module.scss'

export const Timer = (props :any) => {
    const { seconds, onFinish } = props
    const date = new Date(0);
    const [timeLeft, setTimeLeft] = useState(seconds);
    useEffect(() => {
        setTimeLeft(seconds)
    }, [seconds])
    useEffect(() => {
        if (!timeLeft) {
            onFinish()
            return;
        }
        const intervalId = setInterval(() => {
            setTimeLeft(timeLeft - 1);
        }, 1000);
        return () => clearInterval(intervalId);
    }, [timeLeft]);
    date.setMilliseconds(timeLeft * 1000)
    return(
        <p className={classes.timer}>{date.toISOString().substr(15, 4)}</p>
    )
}